// useAddOrderToStore.js
// ############################
// adds or updates a specifi record
// by usung "setDoc" with a unique identifier
// in this example the basketID
// ############################

import { useEffect } from 'react';
import { setDoc, doc } from 'firebase/firestore';
import { db } from '@/app/firebase/config';

function useAddBasketToStore() {
  const addBasketToStore = async (data, collectionName) => {
    console.log(data);
    // console.log('Data being added to the store : ' + collectionName);
    try {
      if (data) {
        // Assuming orderData.basketID is unique for each basket
        const orderRef = doc(db, collectionName, data.basketID);

        await setDoc(orderRef, data);
        // Handle successful addition here, if needed
      } else {
        console.warn(
          'orderData is null or undefined. Skipping order processing.'
        );
      }
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  };

  useEffect(() => {
    // Call any initialization logic for the hook here, if needed.
  }, []);

  return addBasketToStore;
}

export default useAddBasketToStore;
